import {IonSelectOption} from '@ionic/react';
import styled from 'styled-components';

export const StyledIonSelectOption = styled(IonSelectOption)`
	.alert-radio-label.sc-ion-alert-ios {
		white-space: normal !important;
	}
`;
